import { render, staticRenderFns } from "./Expedition.vue?vue&type=template&id=3f1c3771"
import script from "./Expedition.vue?vue&type=script&lang=js"
export * from "./Expedition.vue?vue&type=script&lang=js"
import style0 from "./Expedition.vue?vue&type=style&index=0&id=3f1c3771&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports